import heic2any from "heic2any"

const HEIC_EXTENSIONS = new Set(["heic", "heif"])

const getExtension = (filename: string): string =>
  filename.split(".").pop()?.toLowerCase() ?? ""

export const isHeicFilename = (filename: string): boolean =>
  HEIC_EXTENSIONS.has(getExtension(filename))

export const isHeicFile = (file: File): boolean =>
  isHeicFilename(file.name) ||
  file.type === "image/heic" ||
  file.type === "image/heif"

const normalizeHeicResult = (result: Blob | Blob[]): Blob =>
  Array.isArray(result) ? result[0] : result

const toJpegFilename = (filename: string): string => {
  const trimmed = filename.trim()
  if (!trimmed) return "image.jpg"

  const lastDotIndex = trimmed.lastIndexOf(".")
  const hasBasename = lastDotIndex > 0
  const baseName = hasBasename ? trimmed.slice(0, lastDotIndex) : trimmed

  return `${baseName}.jpg`
}

/**
 * Converts a HEIC/HEIF file to JPEG. Returns the original file unchanged
 * if it's not HEIC.
 */
export const convertHeicToJpeg = async (file: File): Promise<File> => {
  if (!isHeicFile(file)) return file

  const blob = normalizeHeicResult(
    await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.92,
    })
  )

  const jpegName = toJpegFilename(file.name)

  return new File([blob], jpegName, {
    type: "image/jpeg",
    lastModified: file.lastModified,
  })
}
